import React, { useState } from "react";
import queryString from "query-string";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import useAxios from "middleware/useAxios";
import { Row, Col } from "antd";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Button, Form, Input, Select, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Icon from "react-multi-date-picker/components/icon";

import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { convertToMiladi } from "utils/dateCoverter";
import Axios from "middleware/axiosInstance";
import DatePicker from "react-multi-date-picker";

const { Option } = Select;
const { TextArea } = Input;

const CreateNewConvert = () => {
  const Navigate = useNavigate();
  const [form] = Form.useForm();

  // start react router url params
  // const UrlParams = useParams();
  // const docType = UrlParams.anbarId
  // console.log(docType);
  // end react router url params
  // return the location object to parse url with useLocation
  const { search } = useLocation();
  // get query string to get user info
  const UrlQueryString = queryString.parse(search);
  const docId = UrlQueryString.DocId;
  const anbarId = UrlQueryString.anbarId;
  console.log(UrlQueryString);
  const [docInfo, setDocInfo] = useState(null);
  const [dayOfDoc, setDayOfDoc] = useState(null);

  const [currentCountOfCommodities, setCurrentCountOfCommodities] = useState(
    []
  );
  const [allCommodity] = useAxios({
    method: "GET",
    url: "/commodity",
  });
  const [allPeople] = useAxios({
    method: "get",
    url: "/people",
  });

  const getCommodityCurrentCount = (commodityId, rowIndex) => {
    Axios.post(`/count/${commodityId}`, {
      anbar_id: anbarId,
    }).then((res) => {
      console.log(res.data.count);
      const temp = [...currentCountOfCommodities];
      temp[rowIndex] = { count: res.data.count };
      setCurrentCountOfCommodities(temp);
      console.log(temp);
      // const response = res.data.count
      // setCurrentCountOfCommodities({ ...currentCountOfCommodities, [rowIndex]: response })
    });
  };
  const handleConvert = (e) => {
    try {
      e.anbar_id = anbarId;
      e.sh_sanad = docId;
      e.date = dayOfDoc.miladi;
      Axios.post("/change", e)
        .then((res) => {
          console.log(res);
          Navigate("/warehouse/warehouse-convert-docs");
          OpenNotificationWithIcon("ثبت موفق", "تبدیل کالا با موفقیت ثبت شد");
        })
        .catch((err) => {
          console.log(err);
          OpenNotificationWithIcon(
            "ثبت ناموفق",
            "تبدیل کالا  ثبت نشد",
            "error"
          );
        });
    } catch {
      alert("مشکلی پیش آمده ثبت نشد");
    }
  };

  const changeDateAndTimeOfDocHandler = (e) => {
    const dateInShamsi = `${e.year}-${e.month.number}-${e.day}`;
    const dateInMiladi = convertToMiladi(dateInShamsi);
    setDayOfDoc({ shamsi: dateInShamsi, miladi: dateInMiladi });
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          تبدیل کالاهای سند ورود به شماره {docId}
        </h5>
        {/* شماره انبار ورودی{anbarId}  */}
        <Form
          // layout="horizental"
          layout="vertical"
          // layout="inline"
          // {...formItemLayout}
          // layout={
          //     "span": 12,
          //     "offset": 12,
          //   },
          initialValues={{
            items: [{ name: "" }],
          }}
          form={form}
          // onValuesChange={handleFormValuesChange}
          autoComplete="off"
          scrollToFirstError
          labelCol={{ xs: 24 }}
          onFinish={handleConvert}
        >
          <Row gutter={8}>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="شخص"
                name="people_id"
                rules={[
                  {
                    required: true,
                    message: "انتخاب شخص اجباری می باشد",
                  },
                ]}
              >
                <Select
                  // className={`${classNames.classes}`}
                  loading={!allPeople?.[0]}
                  showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  fieldNames="people_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="people_id"
                >
                  {allPeople?.map((people) => {
                    return (
                      <Option key={people.id} value={people.id}>
                        {`${people.name} ${people.family}`}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} xl={6}>
              {/* <Form.Item label="تاریخ" name="date">
                < Calendar
                  value={selectedDay}
                  onChange={e => console.log(e)}
                  locale="fa" />
              </Form.Item> */}
              <Form.Item
                label="تاریخ"
                name="date"
                rules={[
                  {
                    required: !dayOfDoc,
                    message: "انتخاب تاریخ الزامی می باشد",
                  },
                ]}
              >
                <Input
                  disabled
                  placeholder={dayOfDoc ? dayOfDoc.shamsi : "انتخاب تاریخ"}
                  addonBefore={
                    <DatePicker
                      // value={newWarehouseEntryDocument.date}
                      onChange={(e) => changeDateAndTimeOfDocHandler(e)}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-left"
                      // format="HH:MM"
                      // plugins={[<TimePicker hideSeconds />]}
                      render={
                        <Icon
                          style={{
                            color: "gray",
                            width: "23px",
                          }}
                        />
                      }
                    />
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="شرح" name={"description"}>
                <TextArea
                  row={3}
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  placeholder="توضیحات..."
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={8}>
            <Col xs={24}>
              {/* start form list */}

              <Form.List
                name="items"
                // onValuesChange={(e) => {
                //     console.log(e);
                // }}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "radif"]}
                          label="ردیف"
                        >
                          {/* row number */}
                          {name + 1}
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "mojudi"]}
                          label="موجودی"
                        >
                          {currentCountOfCommodities[name]?.count}
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, "commodity2_id"]}
                          label="شناسه/نام کالا از"
                          // onValuesChange={commodityChangeHandler}
                          rules={[
                            {
                              required: true,
                              message: "انتخاب کالا اجباری است",
                            },
                          ]}
                        >
                          <Select
                            onChange={(e) => {
                              getCommodityCurrentCount(e, name, restField);
                            }}
                            showSearch
                            loading={!allCommodity?.[0]}
                            placeholder="انتخاب فرمایید"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {allCommodity?.map((kala) => {
                              return (
                                <Option key={kala.id} value={kala.id}>
                                  {`${kala.id} -${kala.name}`}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, "count_ex"]}
                          label="تعداد"
                          rules={[
                            {
                              required: true,
                              message: "تعداد کالا اجباری است",
                            },
                            { min: 1 },
                            () => ({
                              validator(_, value) {
                                if (
                                  value > currentCountOfCommodities[name]?.count
                                ) {
                                  return Promise.reject("بیشتر از موجودی");
                                } else return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input type="number" placeholder="100" min="1" onWheel={(e) => e.target.blur()} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "commodity_id"]}
                          label="تبدیل به شناسه/نام کالا"
                          // onValuesChange={commodityChangeHandler}
                          rules={[
                            {
                              required: true,
                              message: "انتخاب کالا اجباری است",
                            },
                          ]}
                        >
                          <Select
                            // onChange={(e) => {
                            //     // getCommodityCurrentCount(e, name, restField);
                            // }}
                            showSearch
                            loading={!allCommodity?.[0]}
                            placeholder="انتخاب فرمایید"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {allCommodity?.map((kala) => {
                              return (
                                <Option key={kala.id} value={kala.id}>
                                  {`${kala.id} -${kala.name}`}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "count_im"]}
                          label="تعداد"
                          rules={[
                            {
                              required: true,
                              message: "تعداد کالا اجباری است",
                            },
                            { min: 1 },
                          ]}
                        >
                          <Input type="number" placeholder="100" min="1" onWheel={(e) => e.target.blur()}/>
                        </Form.Item>
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name);
                            console.log(name);
                            currentCountOfCommodities.splice(name, 1);
                          }}
                        />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        ایجاد یک ردیف جدید
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              {/* end form list */}
            </Col>
          </Row>

          <Form.Item
          // {...buttonItemLayout}
          >
            <Button
              htmlType="submit"
              type="primary"
              // onClick={CreateWarehouseEntryDocumentHandler}
            >
              ثبت
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CreateNewConvert;
